import script from "./ShopOrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopOrderList.vue?vue&type=script&setup=true&lang=js"

import "./ShopOrderList.vue?vue&type=style&index=0&id=284733da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-284733da"]])

export default __exports__